<template>
  <div class="team-memmber-wrap">
    <div class="member-module">
      <div class="title">学霸们四处冲冲冲</div>
      <div class="group-name">青龙1组</div>
      <div class="base-info">
        <div class="info-item">
          <p>服务中心：</p>
          <p>2022103164026658</p>
        </div>
        <div class="info-item">
          <p>ID：</p>
          <p>9999</p>
        </div>
      </div>
      <div class="main-content">
        <div class="module-title">添加战队成员</div>
        <!--数学-->
        <div class="module-section">
          <div class="header">
            <p class="subject-name">数学</p>
            <div class="edit">
              <div class="edit-p">修改</div>
            </div>
          </div>
          <div class="member-ul">
            <div class="member-item" v-for="(item, index) in mathMemberData" :key="`mathMember_${index}`">
              <div class="member-item-box" v-if="item.name">
                <div class="member-photo">高</div>
                <div class="member-name">{{ item.name }}</div>
              </div>
              <div class="member-item-box" v-else>
                <div class="member-item add-member">
                  <div class="member-photo">+</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--语文-->
        <div class="module-section">
          <div class="header">
            <p class="subject-name">语文</p>
            <div class="edit">
              <div class="edit-p">修改</div>
            </div>
          </div>
          <div class="member-ul two">
            <div class="member-item" v-for="(item, index) in chineseMemberData" :key="`mathMember_${index}`">
              <div class="member-item-box" v-if="item.name">
                <div class="member-photo">高</div>
                <div class="member-name">{{ item.name }}</div>
              </div>
              <div class="member-item-box" v-else>
                <div class="member-item add-member">
                  <div class="member-photo">+</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--英语-->
        <div class="module-section">
          <div class="header">
            <p class="subject-name">英语</p>
            <div class="edit">
              <div class="edit-p">修改</div>
            </div>
          </div>
          <div class="member-ul two">
            <div class="member-item" v-for="(item, index) in englishMemberData" :key="`mathMember_${index}`">
              <div class="member-item-box" v-if="item.name">
                <div class="member-photo">高</div>
                <div class="member-name">{{ item.name }}</div>
              </div>
              <div class="member-item-box" v-else>
                <div class="member-item add-member">
                  <div class="member-photo">+</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-button-wrap">
      <div class="submit-button">提交</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      mathMemberData: [
        {name: '高'},
        {name: '高'},
        {name: '高'},
        {name: ''},
        {name: ''},
        {name: ''},
      ],
      chineseMemberData: [
        {name: '高'},
        {name: ''},
      ],
      englishMemberData: [
        {name: '高'},
        {name: ''},
      ],
    }
  }
};
</script>

<style lang="less">
#app {
  height: 100%;
}
.team-memmber-wrap {
  width: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;
  .member-module {
    width: 100%;
    height: 90%;
    overflow-y: auto;
  }
  .title {
    margin-top: 32px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #323232;
    text-align: center;
  }
  .group-name {
    width: 208px;
    height: 46px;
    margin: 8px auto 0;
    background: rgba(88, 171, 246, 0.16);
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #619cf5;
  }
  .base-info {
    margin: 32px;
    padding-bottom: 32px;
    border-bottom: 1px solid #e6e6e6;
    .info-item {
      display: flex;
      margin-bottom: 24prx;
      justify-content: space-between;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #68707d;
    }
  }
  .main-content {
    margin: 0 32px;
  }
  .module-title {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #323232;
  }
  .module-section .header {
    position: relative;
    width: 100%;
    height: 64px;
    margin-top: 16px;
    background: rgba(88, 171, 246, 0.2);
    border-radius: 16px;
    text-align: center;
    line-height: 64px;
    .subject-name {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #323232;
    }
    .edit {
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 64px;
      display: flex;
      align-items: center;
      .edit-text {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #58abf6;
      }
    }
  }
  .member-ul {
    margin-top: 32px;
    display: grid;
    justify-content: space-around;
    flex-wrap: wrap;
    grid-template-columns: repeat(3, 33.33%);
    .member-item {
      .member-item-box {
        width: 112px;
        height: 156px;
        margin: 0 auto 32px;
        .member-photo {
          width: 112px;
          height: 112px;
          background: #58abf6;
          border-radius: 50%;
          font-size: 48px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .member-name {
          margin-top: 4px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #323232;
          text-align: center;
        }
      }
      &.add-member {
        .member-photo {
          background: #ececec;
          color: #000000;
        }
      }
    }
    &.two {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .submit-button-wrap {
    text-align: center;
  }
  .submit-button {
    width: 600px;
    height: 96px;
    margin: 0 auto;
    background: #58abf6;
    border-radius: 57px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.8;
    }
  }
}
</style>